import { defineComponent, PropType } from 'vue';
import { MentionMemberCommonLinkTextNode } from '_c/typings/model/chat';

export default defineComponent({
  name: 'MentionMemberTextNode',
  props: {
    text: {
      type: String as PropType<string>,
      default: '',
    },
    innerText: {
      type: String as PropType<string>,
      default: '',
    },
    displayText: {
      type: String as PropType<string>,
      default: '',
    },
  },
  data(): {
    mentionMemberInfo?: MentionMemberCommonLinkTextNode
  } {
    return {
      mentionMemberInfo: undefined,
    };
  },
  created(): void {
    // 已在generate-text-node-config中前置检查
    const map: Record<string, unknown> = JSON.parse(this.innerText);
    this.mentionMemberInfo = {
      uid: Number(map?.uid),
      nickName: map?.nickName ? `${map.nickName}` : '',
    };
  },
  methods: {
    onMemberClick(): void {
      // TODO
      // if (this.mentionMemberInfo.uid > 0) {
      //   this.chatPageEventBus.emit(ChatPageEventType.avatarClick, {
      //     uid: `${this.mentionMemberInfo.uid}`,
      //   });
      // }
    },
  },
});
